
export const commonMixin = {
  data: function () {
    return {

    }
  },
  props: {

  },
  computed: {
    routeList: {
      get: function () {
        return this.$store.state.routeList
      },
      set: function () {}
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    getParam (key) {
      if (this.$route.params) {
        if (this.$route.params[key]) {
          return this.$route.params[key]
        }
      }
      return null
    },
    isNull (obj) {
      if (obj === undefined || obj === '') {
        return true
      }
      return false
    },
    isNotNull (obj) {
      return !isNull(obj)
    },
    getRouterList (params) {
      if (this.routeList.length > 0) {
        var n = 0
        for (var i = 0; i < this.routeList.length; i++) {
          if (params.title === this.routeList[i].title) {
            n = n + 1
          }
        }
        if (n == 0) {
          this.routeList.push(params)
        }
      } else {
        this.routeList.push(params)
      }
      document.title = params.title
      sessionStorage.setItem('routerParams', JSON.stringify(params))
      this.$store.commit('setRouteList', this.routeList)// 缓存路由标签数据
    },
    openByName (name, params, query) {
      let route = {name: name}
      if (params) {
        if(typeof params === 'string'){
          route.params = JSON.parse(params)
        }else{
          route.params = params
        }

      }
      if (query) {
        route.query = JSON.parse(query)
      }
      // console.info('--------111-------'+typeof params)
      // console.info(route)
      // console.info(params);
      // this.$router.push(route);
      this.$router.push({
        name: name,
        params: route.params
      })
      try {
        let param = JSON.parse(params)
        let node = {
          formKey: param.formKey,
          name: name,
          title: param.title,
          params: param
        }
        if (node && node.title) {
          this.getRouterList(node)
        }
      } catch (error) {
        console.log('无法解析params')
      }
      // node.title = '支出合同'
    },
    openByPath (path, query, params) {
      let route = {path: path}
      if (params) {
        route.params = params
      }
      if (query) {
        route.query = query
      }
      console.info('--------222-------')
      this.$router.push(route)
    },
    warn (msg) {
      this.util.warn(msg)
    },
    info (msg) {
      this.util.info(msg)
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/commonMixin.js